import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Client } from 'src/users';
import DrawerFlow, { DrawerFlowStep } from 'src/UI/drawer-flow/DrawerFlow';
import SelectRecordingStep from './steps/SelectRecordingStep';
import MeetingNoteSelectTemplateStep from './steps/MeetingNoteSelectTemplateStep';
import MeetingNoteProgressOneSvg from './assets/meeting-note-progress-one.svg?react';
import MeetingNoteProgressTwoSvg from './assets/meeting-note-progress-two.svg?react';
import MeetingNoteProgressThreeSvg from './assets/meeting-note-progress-three.svg?react';
import MeetingNoteSelectClientStep from './steps/MeetingNoteSelectClientStep';

type MeetingNoteFlowProps = {
  opened: boolean;
  close: () => void;
};

type MeetingNoteData = {
  client?: Client;
  selectedRecordingId?: string;
  selectedTemplateId?: string;
};

const initialData: MeetingNoteData = {
  client: undefined,
  selectedRecordingId: undefined,
  selectedTemplateId: undefined,
};

const steps: DrawerFlowStep<MeetingNoteData>[] = [
  {
    title: 'Select client',
    showClientName: false,
    screens: [
      {
        component: MeetingNoteSelectClientStep,
        renderProgress: () => <MeetingNoteProgressOneSvg />,
      },
    ],
  },
  {
    title: 'Select recording',
    clientNamePrefix: 'for',
    screens: [
      {
        component: SelectRecordingStep,
        renderProgress: () => <MeetingNoteProgressTwoSvg />,
      },
    ],
  },
  {
    title: 'Select template',
    clientNamePrefix: 'for',
    screens: [
      {
        component: MeetingNoteSelectTemplateStep,
        renderProgress: () => <MeetingNoteProgressThreeSvg />,
      },
    ],
  },
];

export default function MeetingNoteFlow({ opened, close }: MeetingNoteFlowProps) {
  const navigate = useNavigate();
  const [data, setData] = useState<MeetingNoteData>(initialData);

  const onSuccess = useCallback(
    (data: MeetingNoteData) => {
      const clientId = data.client?.id;
      navigate(`/client/${clientId}/document/meeting-notes`);
    },
    [navigate],
  );

  return (
    <DrawerFlow
      opened={opened}
      close={close}
      title="Meeting note"
      steps={steps}
      initialData={initialData}
      data={data}
      setData={setData}
      onSuccess={onSuccess}
    />
  );
}
